const map = {
	"./arrowbullet.js": [
		9966,
		[
			966
		]
	],
	"./consultant.js": [
		1954,
		[
			954
		]
	],
	"./home.js": [
		4676,
		[
			676
		]
	],
	"./info.js": [
		307,
		[
			307
		]
	],
	"./mail.js": [
		3052,
		[
			52
		]
	],
	"./services.js": [
		9311,
		[
			311
		]
	],
	"./support.js": [
		6988,
		[
			988
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3455;
module.exports = webpackAsyncContext;